import { Col, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import hocFrom from '../../../components/forms/HocFrom'
import InputFarsi from '../../../components/inputs/InputFarsi'
import Switchrs from '../../../components/inputs/Switchrs'
import Loader from '../../../components/layout/Loader'

const FromContact = ({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata }) => {


    const handelValue = (name, value) => {
        switch (name) {
            case 'name':
                handelsetdataForm({ ...formdata, name: value })
                break;
            case 'cellPhone':
                handelsetdataForm({ ...formdata, cellPhone: value })
                break;
            case 'email':
                handelsetdataForm({ ...formdata, email: value })
                break;
            case 'title':
                handelsetdataForm({ ...formdata, title: value })
                break;
            case 'message':
                handelsetdataForm({ ...formdata, message: value })
                break;
            case 'replay':
                handelsetdataForm({ ...formdata, replay: value })
                break;
            case 'IsSeenFromContact':
                handelsetdataForm({ ...formdata, isSeen: value })
                break;
            default:

                break;
        }
    }

    const handelSubmit = event => {
        event.preventDefault()
        handelLoadingform(true)

        if (!formdata.name) {
            toast.error('وارد کردن نام اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.cellPhone) {
            toast.error('وارد کردن شماره تماس اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        // else if (!formdata.email) {
        //     toast.error('وارد کردن ایمیل اجباری است', {
        //         position: "bottom-left",
        //         autoClose: 5000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //     });
        //     handelLoadingform(false)
        // }
        // else if (!formdata.title) {
        //     toast.error('وارد کردن عنوان اجباری است', {
        //         position: "bottom-left",
        //         autoClose: 5000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //     });
        //     handelLoadingform(false)
        // }
        else if (!formdata.message) {
            toast.error('وارد کردن متن پیام اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else {
            dataUpdate.name ? handelUpdataFrom() : handelSend()
        }
    }
    return (
        <>
            {
                loding ?
                    <Loader />
                    : <Form>
                        <Form.Row>
                            <Col>
                                <InputFarsi label='نام' name='name' defaultValue={dataUpdate.name} handelValue={handelValue} />
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>شماره تماس</Form.Label>
                                    <Form.Control name='cellPhone' defaultValue={dataUpdate ? dataUpdate.cellPhone : ''} onChange={(e) => handelValue('cellPhone', e.target.value)} />
                                </Form.Group>

                            </Col>
                            {/* <Col>
                                <Form.Group>
                                    <Form.Label>ادرس ایمل</Form.Label>
                                    <Form.Control name='email' defaultValue={dataUpdate ? dataUpdate.email : ''} onChange={(e) => handelValue('email', e.target.value)} />
                                </Form.Group>
                            </Col> */}
                        </Form.Row>
                        {/* <Form.Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>عنوان</Form.Label>
                                    <Form.Control name='title' defaultValue={dataUpdate ? dataUpdate.title : ''} onChange={(e) => handelValue('title', e.target.value)} />
                                </Form.Group>
                            </Col>

                        </Form.Row> */}
                        <Form.Row>
                            <Col>

                                <div className="form-group">
                                    <label for="replayTextarea">متن پیام</label>
                                    <textarea className="form-control" id="replayTextarea" rows="6" defaultValue={dataUpdate ? dataUpdate.message : ''} onChange={(e) => handelValue('message', e.target.value)} ></textarea>
                                </div>
                            </Col>

                            <Col>
                                <div className="form-group">
                                    <label for="replayTextarea">متن پاسخ</label>
                                    <textarea className="form-control" id="replayTextarea" rows="6" defaultValue={dataUpdate ? dataUpdate.replay : ''} onChange={(e) => handelValue('replay', e.target.value)} ></textarea>
                                </div>
                            </Col>
                        </Form.Row>
                        <Switchrs label='پیام دیده شده است' name='IsSeenFromContact'
                            checke={formdata.isSeen}
                            handelValue={handelValue}
                        />
                        <Form.Row>
                            <Col className="mt-3" >
                                <button type='submit' className='btn btn-success' onClick={handelSubmit} disabled={LoadingForm} >
                                    {LoadingForm ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : dataUpdate.name ? "ثبت ویرایش" : "ثبت"}
                                </button>
                            </Col>
                        </Form.Row>
                    </Form>
            }
        </>
    )
}

export default hocFrom(FromContact)